export default __webpack_public_path__ + "static/media/shield1.bc7bac93.png";